import React from "react";
import Svg from "@natera/material/lib/svg";

import { PaymentCardBrand } from "@app/postBill/models/apiControllerModel";
import EditIcon from "@app/postBill/assets/svg/edit-icon.svg";
import Visa from "@app/postBill/assets/svg/visa.svg";
import Amex from "@app/postBill/assets/svg/american-express.svg";
import Discover from "@app/postBill/assets/svg/discover.svg";
import MasterCard from "@app/postBill/assets/svg/master-card.svg";
import DinnersClub from "@app/postBill/assets/svg/dinners-club.svg";
import EftPos from "@app/postBill/assets/svg/eftpos.svg";
import Jcb from "@app/postBill/assets/svg/jcb.svg";
import UnionPay from "@app/postBill/assets/svg/union-pay.svg";
import Default from "@app/postBill/assets/svg/default.svg";

import "./paymentCardDisplay.scss";

interface PaymentCardDisplayProps {
  brand: PaymentCardBrand;
  lastFour: string;
  expiryDate: string;
  onEditClick?: () => void;
}

export const getPaymentCardBrandLogo = (brand: PaymentCardBrand): string => {
  switch (brand) {
    case PaymentCardBrand.VISA:
      return Visa;
    case PaymentCardBrand.AMEX:
      return Amex;
    case PaymentCardBrand.DISCOVER:
      return Discover;
    case PaymentCardBrand.MASTERCARD:
      return MasterCard;
    case PaymentCardBrand.DINERS:
      return DinnersClub;
    case PaymentCardBrand.EFTPOS_AU:
      return EftPos;
    case PaymentCardBrand.JCB:
      return Jcb;
    case PaymentCardBrand.UNIONPAY:
      return UnionPay;
    default:
      return Default;
  }
};

const PaymentCardDisplay: React.FC<PaymentCardDisplayProps> = ({
  brand,
  lastFour,
  expiryDate,
  onEditClick,
}) => {
  return (
    <div className="payment-card">
      <Svg
        className="payment-card__logo"
        content={getPaymentCardBrandLogo(brand)}
      />
      <div className="payment-card__info">
        <div className="payment-card__number">•••• {lastFour}</div>
        <div className="payment-card__details">
          <span className="payment-card__expiry">{expiryDate}</span>
        </div>
      </div>
      {onEditClick && (
        <button className="payment-card__edit" onClick={onEditClick}>
          <Svg content={EditIcon} className="payment-card__edit-icon" />
        </button>
      )}
    </div>
  );
};

export default PaymentCardDisplay;
